import { render, staticRenderFns } from "./AppBurgerBodyItem.vue?vue&type=template&id=238cfe69&"
import script from "./AppBurgerBodyItem.vue?vue&type=script&lang=js&"
export * from "./AppBurgerBodyItem.vue?vue&type=script&lang=js&"
import style0 from "./AppBurgerBodyItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports